import React, { useEffect } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { APP_ROUTES, ROUTE_PATHS } from "../../constants/app.constants";
import Header from "./Header";
import "./index.styles.scss";
import SecStackReportPage from "../sec-stack-report/report-page";
import ReportPreviewSharePage from "../sec-stack-report/report-preview-share-page";
import SecStackReportReviewPage from "../sec-stack-report/report-page/sec-stack-review";
import useActions from "../../hooks/service-actions.hook";
import { MspDetailsEffectActions } from "../../common/services/msp-details/msp-details.service";
import { useEntity } from "../../hooks/use-entity.hook";
import { Entities } from "../../common/store/entities/entities.enum";
import ImageLoader from "../Common/ImageLoader";

const SecStackReportRoutes = () => {
  const location = useLocation();
  const  { getMspDetails } = useActions(MspDetailsEffectActions);
  const { mspId } = location.state || {};
  const { entityData: mspDetails } = useEntity({ entityType: Entities.MspDetails, entityId: mspId });

  useEffect(() => {
    if (!mspId) return;
    getMspDetails({ mspId });
  }, [mspId]);

  const leftSideComponent = mspDetails?.MSPName ? (
    <div className="ml-4 d-flex align-items-center">
      <ImageLoader 
        src={mspDetails?.MSPLogo}
        className="mr-2"
        style={{ width: "28px", height: "28px" }}
        noImageComponent={(
          <img src="/images/user-logo.svg" className="mr-2" style={{ width: "28px", height: "28px" }} />
        )}
      />
      <h3 className="m-0 f-14 line-height-22">{mspDetails?.MSPName}</h3>
    </div>
  ) : null;

  return (
    <div id="body-container-id" className="body-container hide-scrollbar">
      <Header isLoading={false} accountId={undefined} data={undefined} leftSideComponent={leftSideComponent} />

      <Routes>
        <Route path="" element={<SecStackReportPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.secStackReportReview.split('/').slice(-1)[0]} element={<SecStackReportReviewPage />} />
        <Route path={APP_ROUTES.subscriptionPortalPages.secStackReportPreviewShare.split('/').slice(-1)[0]} element={<ReportPreviewSharePage />} />
        <Route path="*" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.overview} replace />} />
      </Routes>
    </div>
  );
}

export default SecStackReportRoutes;
